
import { useEffect } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/contexts/auth";
import { useToast } from "@/hooks/use-toast";

// Routes that are accessible without authentication
const PUBLIC_ROUTES = ['/refund', '/preview'];

export const ProtectedRoute = ({ children }: { children: React.ReactNode }) => {
  const { user, isLoading } = useAuth();
  const location = useLocation();
  const { toast } = useToast();
  const isPublicRoute = PUBLIC_ROUTES.includes(location.pathname);

  useEffect(() => {
    if (!isLoading && !user && !isPublicRoute) {
      toast({
        title: "Authentication required",
        description: "Please sign in to access this page",
      });
    }
  }, [isLoading, user, toast, isPublicRoute]);

  if (isLoading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="animate-spin h-8 w-8 border-4 border-primary border-t-transparent rounded-full"></div>
      </div>
    );
  }

  // Allow access to public routes even without authentication
  if (!user && isPublicRoute) {
    return <>{children}</>;
  }

  if (!user) {
    return <Navigate to="/auth" state={{ from: location }} replace />;
  }

  return <>{children}</>;
};
